import { cn } from "@thilke/ui/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

const panelVariants = cva(
  "rounded-[5px] border-2 text-card-foreground shadow-sm",
  {
    variants: {
      position: {
        floating:
          "absolute border-border bg-chrome shadow-md backdrop-blur supports-[backdrop-filter]:bg-chrome/90",
        docked: "border-border bg-card",
      },
      size: {
        sm: "p-1",
        md: "p-2",
        lg: "p-3",
      },
    },
    defaultVariants: {
      position: "docked",
      size: "md",
    },
  },
);

function Panel({
  className,
  position,
  size,
  ...props
}: React.ComponentProps<"div"> & VariantProps<typeof panelVariants>) {
  return (
    <div
      data-slot="panel"
      className={cn(panelVariants({ position, size, className }))}
      {...props}
    />
  );
}

export { Panel, panelVariants };
